const GallonType = ({ setFilterFn }) => {
  const handleClick = (choice) => {
    setFilterFn({
      choice: choice,
      filterClassification: "results",
      filterType: "size",
      nextFilter: "results",
    })
  }

  return (
    <div>
      <h2 className="selection-title">I need to transport...</h2>
      <div className="col-sm-6 col-md-4" onClick={ () => handleClick("small") }>
        <div className="selection-box">
          <img src="/assets/bat_1-2gal.jpg" className="bat-image" />
          <br />
          <span>1.5 To 2.5 Gallons</span>
        </div>
      </div>
      <div className="col-sm-6 col-md-4" onClick={ () => handleClick("medium") }>
        <div className="selection-box">
          <img src="/assets/bat_3-5gal.jpg" className="bat-image" />
          <br />
          <span>3.75 To 5.25 Gallons</span>
        </div>
      </div>
      <div className="col-sm-6 col-md-4 col-sm-offset-3 col-md-offset-0" onClick={ () => handleClick("large") }>
        <div className="selection-box">
          <img src="/assets/bat_10gal.jpg" className="bat-image" />
          <br />
          <span>10+ Gallons</span>
        </div>
      </div>
    </div>
  )
}

export default GallonType
